import { convertMinorAmountToMajor } from '@/legacy/store/helpFunctions'
import type { Order, OrderListFilter, OrderRaw, OrdersParams } from '@/lib/types/orders.types'
export const normalizeOrder = (raw: OrderRaw): Order => ({
  orderAt: raw.order_at,
  id: raw.order_id,
  userId: raw.user_id,
  username: raw.username,
  orderValue: convertMinorAmountToMajor(raw.order_value),
  status: raw.status,
  updatedAt: raw.updated_at,
})
export const normalizeOrders = (rawList: OrderRaw[]): Order[] => rawList.map(normalizeOrder)
export const handleOrdersFilter = (filter: OrderListFilter): OrdersParams => ({
  ...(filter.dateFrom && filter.dateTo && { from: filter.dateFrom, to: filter.dateTo }),
  page: filter.page,
})
